import {CornerDialog, Pane, toaster} from "evergreen-ui";
import Headerpanel from "../../component/headerpanel";
import {useEffect, useState} from "react";
import DatatableODTE from "../../component/datatable";
import type {HeaderTableType} from "../../../types/header-table.type";
import {type DatatableContactType} from "./../../../types/datatable-contact.type";
import {ContactService} from "./../../../services/contact.service";
import {type ContactType} from "../../../types/contact.type";

export const Courriels = () => {
   const HeaderLabel: HeaderTableType[] = [
      {key: "nom", label: "Nom", isFilter: true},
      {key: "email", label: "Email", isFilter: false},
      {key: "telephone", label: "Tel", isFilter: false},
      {key: "adresse", label: "Adresse", isFilter: false},
      {key: "action", label: "", isFilter: false},
   ];

   const configAction: any = {
      delete: {state: true, url: ""},
      show: {state: true, url: ""},
   };

   const title = "Gestion courriels";
   const [searchValue, setSearchValue] = useState("");
   const [dateValue, setDateValue] = useState("");
   const [listeCourrier, setCourriers] = useState<DatatableContactType>({
      contactListe: [],
      totalRow: 0,
      currentPage: 0,
   });
   const [loading, setLoading] = useState<boolean>(true);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [item, setTempitem] = useState<ContactType>({
      id: undefined,
      nom: "",
      email: "",
      telephone: "",
      adresse: "",
      message: "",
   });
   const [deleteModal, setDeleteModal] = useState<boolean>(false);

   useEffect(() => {
      getListeContact();
   }, [listeCourrier.currentPage]);

   const getListeContact = () => {
      setLoading(true);
      ContactService.getListeContact({
         pageNo: listeCourrier.currentPage,
         pageSize: 10,
         sortBy: "",
         sortDir: searchValue,
      })
         .then(data => {
            setCourriers(prevState => ({
               ...prevState,
               contactListe: data.contactListe,
               currentPage: data.currentPage,
               totalRow: data.totalRow,
            }));
            setLoading(false);
         })
         .catch(() => {})
         .finally(() => {
            setLoading(false);
         });
   };

   function handleDeleteProfile() {
      setDeleteModal(true);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const contactId = item.id.toString();
      if (contactId !== "0") {
         void ContactService.deleteContact(contactId)
            .then(res => {
               if (res.success) {
                  toaster.success("OTDE NOTIFICATION", {
                     description: "Félicitation, le contact a été supprimé",
                  });
                  // Rafraîchir la liste des contacts après la suppression
                  getListeContact();
               }
            })
            .catch(() => {
               // Gérer les erreurs de suppression ici
               toaster.danger("OTDE NOTIFICATION", {
                  description:
                     "Une erreur s'est produite lors de la suppression du contact.",
               });
            })
            .finally(() => {
               setDeleteModal(false);
            });
      }
   }

   const handleBtnSearch = (
      dateValue: string,
      searchValue: string,
      setLoadingButtonSearch: any,
   ) => {
      getListeContact();
      setLoadingButtonSearch(false);
   };

   const handleBtnExport = () => {};

   return (
      <div>
         <div className="px-4 sm:px-0"></div>
         <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
               <Headerpanel
                  title={title}
                  searchValue={searchValue}
                  dateValue={dateValue}
                  handleButtonExport={handleBtnExport}
                  handleButtonSearch={handleBtnSearch}
                  handleDateChanged={setDateValue}
                  showSeachValue={true}
                  showdatechoosed={true}
                  showexportPdf={true}
                  showSearchBtn={true}
                  setSearchValue={setSearchValue}
               />
               <Pane
                  display="flex"
                  flexDirection={"row"}
                  padding={16}
                  borderRadius={3}>
                  <DatatableODTE
                     filterValue={searchValue}
                     tableHeaderlabel={HeaderLabel}
                     tableData={listeCourrier.contactListe}
                     totalRow={listeCourrier.totalRow}
                     loading={loading}
                     handleCurrenyPage={setCourriers}
                     configAction={configAction}
                     handleDelete={ite => {
                        setTempitem(ite);
                        setDeleteModal(true);
                     }}
                  />
                  <CornerDialog
                     title="Gestion de l'application"
                     isShown={deleteModal}
                     confirmLabel={"Supprimer"}
                     cancelLabel={"Annuler "}
                     onConfirm={handleDeleteProfile}
                     onCloseComplete={() => {
                        setDeleteModal(false);
                     }}>
                     Voulez-vous supprimer cette ligne ?
                  </CornerDialog>
               </Pane>
            </dl>
         </div>
      </div>
   );
};
